import React from 'react';
import PropTypes from 'prop-types';
import { MdPlaylistAdd } from 'react-icons/md';
import AddToPlayListModal from '../../../component/playlist/personal-playlist/AddToPlayListModal';

const AddToPlaylistButton = ({ selectedVideo }) => {
	const [isModalOpen, setIsModalOpen] = React.useState(false);
	return (
		<React.Fragment>
			<li style={{ cursor: 'pointer' }} onClick={() => setIsModalOpen(true)}>
				<a className="c-video-button">
					<p>
						<span className="svg-2">
							<MdPlaylistAdd size={21} />
						</span>
					</p>
					<p className="c-mobile-text">Add to playlist</p>
				</a>
			</li>

			<AddToPlayListModal
				modal={isModalOpen}
				setModal={setIsModalOpen}
				activeObject={selectedVideo}
				viewData={selectedVideo}
			/>
		</React.Fragment>
	);
};

AddToPlaylistButton.propTypes = {
	selectedVideo: PropTypes.shape({
		_id: PropTypes.string
	})
};

export default AddToPlaylistButton;
